import { useContext } from "react";
import { AuthContext } from "../../Context/AuthContext";
import { useMutation, useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";

export const useUploadVesselImages = () => {
  const { token } = useContext(AuthContext);
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const vesselId = localStorage.getItem('vesselId');

  const uploadVesselImages = async (formData) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/vessel/upload/images/${vesselId}`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: formData,
        }
      );

      if (!response.ok) {
        const errorResponse = await response.json(); 
        throw new Error(errorResponse.message); 
      }

      return response.json(); 
    } catch (error) {
      throw new Error(error.message); 
    }
  };

  return useMutation(uploadVesselImages, {
    onSuccess: () => {
      queryClient.invalidateQueries("vesselImages");
      navigate("/veseelprimarydoc");
    },
  });
};
